function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M7.28569 12.5714C8.54805 12.5714 9.57139 11.548 9.57139 10.2857C9.57139 9.02334 8.54805 8 7.28569 8C6.02334 8 5 9.02334 5 10.2857C5 11.548 6.02334 12.5714 7.28569 12.5714Z",
  fill: "#3448C9"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M21.2857 12.5714C22.548 12.5714 23.5714 11.548 23.5714 10.2857C23.5714 9.02334 22.548 8 21.2857 8C20.0233 8 19 9.02334 19 10.2857C19 11.548 20.0233 12.5714 21.2857 12.5714Z",
  fill: "#3448C9"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M14.2857 12.5714C15.548 12.5714 16.5714 11.548 16.5714 10.2857C16.5714 9.02334 15.548 8 14.2857 8C13.0233 8 12 9.02334 12 10.2857C12 11.548 13.0233 12.5714 14.2857 12.5714Z",
  fill: "#3448C9"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M28.8 4.2087V9.0087C28.8 9.6687 28.26 10.2087 27.6 10.2087C26.94 10.2087 26.4 9.6687 26.4 9.0087V4.2087C26.4 3.5967 25.932 3.0807 25.32 3.0207C25.26 3.0207 25.224 3.0087 25.188 3.0087H3.6C2.952 3.0087 2.4 3.5607 2.4 4.2087V16.2087C2.4 16.8567 2.952 17.4087 3.6 17.4087H6V20.7807L9.228 17.9967L9.912 17.4087H18C18.66 17.4087 19.2 17.9487 19.2 18.6087C19.2 19.2687 18.66 19.8087 18 19.8087H10.8L5.58 24.3207C5.364 24.5127 5.088 24.6087 4.8 24.6087C4.632 24.6087 4.464 24.5727 4.296 24.5007C3.876 24.3087 3.6 23.8767 3.6 23.4087V19.8087C1.62 19.8087 0 18.1887 0 16.2087V4.2087C0 2.2287 1.62 0.608704 3.6 0.608704H25.2C25.32 0.608704 25.452 0.620704 25.56 0.632704C27.372 0.812704 28.8 2.3487 28.8 4.2087Z",
  fill: "#3448C9"
});

function SvgGetTemplate(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 29 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGetTemplate);
export default __webpack_public_path__ + "static/media/getTemplate.775cf780.svg";
export { ForwardRef as ReactComponent };